module.exports = __webpack_public_path__ + "static/undraw_building_blocks_n0nc.0e49379a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/graphics/undraw_building_blocks_n0nc.svg
// module id = 487
// module chunks = 33781710060979